export default __webpack_public_path__ + "static/media/68@2x-8.4a50e2b9.png";